import ManagedServices from "@/pages/ManagedServices/ManagedServices.vue";

import { createBreadCrumbs, setNavigator } from "@/router/routerFunction";


export function routesManagedServices() {
  return [
    {
      path: "/servizi-gestiti",
      name: "Servizi Gestiti",
      component: ManagedServices,
      meta: {
        breadcrumbs: [
          {
            name: "solutions",
            url: "",
          },
          {
            name: "managedService",
            url: "",
          },
        ],
        indexRoute: "servizi-gestiti",
        permissions: ["servizi_gestiti"],
      },
      beforeEnter: [createBreadCrumbs, setNavigator],
    },
      
    {
      path: "/managed-services",
      name: "Managed Services",
      component: ManagedServices,
      meta: {
        breadcrumbs: [
          {
            name: "solutions",
            url: "",
          },
          {
            name: "managedService",
            url: "",
          },
        ],
        indexRoute: "managed-services",
        permissions: ["servizi_gestiti"],
      },
      beforeEnter: [createBreadCrumbs, setNavigator],
    }
  ]
}